import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LocationCoords = {
  lat: number;
  lng: number;
};

export type LocationSearchState = {
  coords: LocationCoords | null;
  sortByDistance: boolean;
  community: string | null;
  nationwideTotal: number;
  communities: string[];
  hasSearched: boolean;
};

const initialState: LocationSearchState = {
  coords: null,
  sortByDistance: false,
  community: null,
  nationwideTotal: 0,
  communities: [],
  hasSearched: false,
};

const areSameCommunities = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((value, index) => value === b[index]);

const locationSearchSlice = createSlice({
  name: 'locationSearch',
  initialState,
  reducers: {
    setCoords: (state, action: PayloadAction<LocationCoords>) => {
      state.coords = action.payload;
      state.sortByDistance = true;
      state.hasSearched = true;
      state.community = null;
    },
    toggleCommunity: (state, action: PayloadAction<string>) => {
      const next = action.payload;
      state.community = state.community === next ? null : next;
    },
    clearCommunity: (state) => {
      state.community = null;
    },
    setNationwideTotal: (state, action: PayloadAction<number>) => {
      if (state.nationwideTotal > 0 || action.payload <= 0) {
        return;
      }
      state.nationwideTotal = action.payload;
    },
    setCommunities: (state, action: PayloadAction<string[]>) => {
      if (state.community) {
        return;
      }
      if (areSameCommunities(state.communities, action.payload)) {
        return;
      }
      state.communities = action.payload;
    },
    resetSearch: () => initialState,
  },
});

export const {
  setCoords,
  toggleCommunity,
  clearCommunity,
  setNationwideTotal,
  setCommunities,
  resetSearch,
} = locationSearchSlice.actions;

export default locationSearchSlice.reducer;
